import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomeButton from "../Button";
import fileUploadLogo from "../../assets/attachment-paperclip.svg";
import FileUploadModal from "../Processes/conversations/FileUploadModal";
import OfficerRegistered from "./OfficerRegistered";
import useAddAttachments from "./useAddAttachments";
import AttachmentIcon from "../Processes/conversations/AttachmentIcon";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";

const AddAttachments = ({
  isCongrats,
  setIsCongrats,
  files,
  setFiles,
  entityData,
  type,
  setActiveIndex,
  resetRegData,
  regData,
}) => {
  const {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getType,
    getCategoryAndSubcategoryNames,
    downloadFileHandler,
    handleDelete,
    officerAttachmentConfig,
    role,
  } = useAddAttachments(files, setFiles, type, regData);
  return (
    <>
      {!isCongrats ? (
        <div className="formgrid grid">
          <div className="w-full flex justify-content-between mb-4">
            <div>
              <p className="add-new-entity-heading mb-2">Attachments</p>
              <p className="input-label m-0">
                {officerAttachmentConfig?.attachmentDescription}
              </p>
            </div>
            <div className="btns-container flex align-items-center">
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          </div>
          {files.length === 0 && (
            <div className="no-documents-uploaded-section w-full">
              <img
                src={fileUploadLogo}
                alt="file-upload"
                className="file-upload-logo"
              />
              <p className="add-new-entity-heading mb-0">
                No Documents uploaded yet
              </p>
              <p className="drag-drop-text m-0">
                {officerAttachmentConfig?.noDocUploadedDescription}
              </p>
              <CustomeButton
                label="Upload File"
                icon="pi pi-upload"
                iconPos="right"
                onClick={() => setShowUploadModal(true)}
              />
            </div>
          )}
          {files.length > 0 && (
            <DataTable
              value={files}
              className="w-full datatable-right-align"
              emptyMessage="No attachments found"
            >
              <Column
                header="Name"
                body={(data) => (
                  <div className="flex align-items-center">
                    <div className="attachment-icon-container">
                      <AttachmentIcon file={data.file} />
                    </div>
                    <a
                      className="request__link"
                      onClick={() => downloadFileHandler(data.file)}
                    >
                      {data.file.fileName}
                    </a>
                  </div>
                )}
              />
              <Column
                header="Category"
                body={(data) =>
                  getCategoryAndSubcategoryNames(
                    data.file.category,
                    data.file.subcategory,
                  ).categoryName
                }
              />
              <Column
                header="Subcategory"
                body={(data) =>
                  getCategoryAndSubcategoryNames(
                    data.file.category,
                    data.file.subcategory,
                  ).subCategoryName
                }
              />
              <Column
                body={(data) => (
                  <div className="flex flex-row gap-0">
                    <Button
                      icon="pi pi-download"
                      severity="secondary"
                      className="p-button-rounded p-button-text"
                      onClick={() => downloadFileHandler(data.file)}
                      tooltip="Download"
                      tooltipOptions={{ position: "top" }}
                    />
                    <Button
                      icon="pi pi-trash"
                      severity="secondary"
                      className="p-button-rounded p-button-text"
                      onClick={() => handleDelete(data)}
                      tooltip="Delete"
                      tooltipOptions={{ position: "top" }}
                    />
                  </div>
                )}
              />
            </DataTable>
          )}
        </div>
      ) : (
        <OfficerRegistered
          setActiveIndex={setActiveIndex}
          resetRegData={resetRegData}
          setIsCongrats={setIsCongrats}
          type={type}
        />
      )}
      <FileUploadModal
        entitydata={entityData}
        showModal={showUploadModal}
        fileSupported={fileSupported}
        hideUploadModal={() => setShowUploadModal(false)}
        setUploadedFile={uploadFileHandler}
        getService={getType}
        placeholder={"Choose a file to upload"}
        relatedType={"OFFICER_ONBOARDING"}
        uploadedFile={files}
        categories={mergeCategories(["Entities +"], role)}
      />
    </>
  );
};

export default AddAttachments;
